module.exports = __webpack_public_path__ + "static/media/place-marker.43e0d331.svg";